module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/facebook-53b8f863483118a6852d458d1e2dad24.png";